export class OrderType {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}
